import React from "react";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import { FaGlobe } from "react-icons/fa";

const projects = [
  {
    name: "Yashmia Consulting Technologies",
    url: "https://yashmia.com/",
    stack: {
      wordpress: true,
      react: false,
      tailwind: false,
      mongodb: false,
    },
    image:
      "https://res.cloudinary.com/dv5jjlsd7/image/upload/v1732467356/Projects/Screenshot_2024-11-24_222454_bjzie9.png",
  },
  {
    name: "Yoga First Landing Page",
    url: "https://yoga-landing-page-amber.vercel.app/",
    stack: {
      react: true,
      tailwind: true,
      mongodb: false,
    },
    image:
      "https://res.cloudinary.com/dv5jjlsd7/image/upload/v1750840387/Projects/Screenshot_20250625_135538_mb4xkc.png",
  },
  {
    name: "MernStack Auth",
    url: "https://mern-auth-client-gamma.vercel.app/",
    stack: {
      react: true,
      tailwind: true,
      express: true,
      mongodb: true,
    },
    image:
      "https://res.cloudinary.com/dv5jjlsd7/image/upload/v1751010116/Projects/Screenshot_20250627_131105_nbqsrt.png",
  },
  {
    name: "OnLearn Education",
    url: "https://onlearn-education-web-site.vercel.app/",
    stack: {
      react: true,
      tailwind: true,
      express: true,
      mongodb: true,
    },
    image:
      "https://res.cloudinary.com/dv5jjlsd7/image/upload/v1752301904/Projects/Screenshot_2025-07-12_115846_zfsgzu.png",
  },
];

const Projects = () => {
  const theme = useSelector((state) => state.theme.theme);

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className={`$${
        theme === "dark" ? " text-white" : " text-black"
      } min-h-screen py-16`}
    >
      <div className="container mx-auto px-6 mt-5 lg:mt-5">
        {/* Title Section */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
        >
          <h2 className="text-[38px] lg:text-[48px] font-bold">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-green-400">
              Projects
            </span>
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mt-2 text-lg">
            A selection of my most impactful projects showcasing my expertise.
          </p>
        </motion.div>

        {/* Project Grid */}
        <motion.div
          className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7 mt-10 justify-center text-center"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.2 },
            },
          }}
        >
          {projects.map(({ name, url, image, stack }, index) => (
            <motion.div
              key={index}
              variants={{
                hidden: { opacity: 0, y: 30 },
                visible: { opacity: 1, y: 0 },
              }}
              transition={{ duration: 0.5 }}
              className="w-max"
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
                className={`outline-none shadow-lg transition-all p-5 rounded-lg cursor-pointer border border-gray-600 hover:border-gray-400 hover:shadow-xl $${
                  theme === "dark" ? "hover:bg-gray-700" : "hover:bg-gray-200"
                }`}
              >
                <img
                  src={image}
                  className="w-[280px] lg:w-[400px] rounded-lg object-contain transition-transform duration-300 hover:scale-110"
                  alt={name}
                />
                <h1 className="font-semibold lg:text-[18px] text-[16px] mt-2 mb-2">
                  {name}
                </h1>
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`inline-flex items-center gap-2 text-sm ${
                    theme === "dark" ? " text-white" : "text-black"
                  }  underline hover:underline`}
                >
                  <FaGlobe
                    className={`text-lg ${
                      theme === "dark" ? " text-white" : "text-black"
                    }`}
                  />{" "}
                  Visit Site
                </a>
                <div className=" grid grid-cols-2 md:grid-cols-3 gap-4 mt-2 ">
                  {stack.react && (
                    <div
                      className={`${
                        theme === "dark"
                          ? "bg-white text-gray-800 py-1 px-2 rounded-lg lowercase"
                          : "bg-gray-800 text-white py-1 px-2 rounded-lg lowercase"
                      }`}
                    >
                      React
                    </div>
                  )}
                  {stack.wordpress && (
                    <div
                      className={`${
                        theme === "dark"
                          ? "bg-white text-gray-800 py-1 px-2 rounded-lg lowercase"
                          : "bg-gray-800 text-white py-1 px-2 rounded-lg lowercase"
                      }`}
                    >
                      Wordpress
                    </div>
                  )}
                  {stack.tailwind && (
                    <div
                      className={`${
                        theme === "dark"
                          ? "bg-white text-gray-800 py-1 px-2 rounded-lg lowercase"
                          : "bg-gray-800 text-white py-1 px-2 rounded-lg lowercase"
                      }`}
                    >
                      Tailwind
                    </div>
                  )}
                  {stack.mongodb && (
                    <div
                      className={`${
                        theme === "dark"
                          ? "bg-white text-gray-800 py-1 px-2 rounded-lg lowercase"
                          : "bg-gray-800 text-white py-1 px-2 rounded-lg lowercase"
                      }`}
                    >
                      MangoDB
                    </div>
                  )}
                  {stack.express && (
                    <div
                      className={`${
                        theme === "dark"
                          ? "bg-white text-gray-800 py-1 px-2 rounded-lg lowercase"
                          : "bg-gray-800 text-white py-1 px-2 rounded-lg lowercase"
                      }`}
                    >
                      express
                    </div>
                  )}
                </div>
              </motion.div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Projects;
